module.exports = __webpack_public_path__ + "static/media/test-drive.979284ef.jpg";